import React, { Fragment} from 'react';
import { Loader } from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";
import { useAppContext } from '../Context/AppContext';

const Loading = (props) => {
    let { showLoader, mainContent, customLoading,transparent = false } = props;
    const {theme} = useAppContext();
    let loadBackGround = '';
    if(theme === 'light-theme'){
        loadBackGround = "#f5f5f5";
    }
    if(transparent){
        loadBackGround = "rgba(245, 245, 245, 0) !important";
    }
    let loaderType = "ball-clip-rotate";
    if(customLoading !== undefined){
        loaderType = customLoading;
    }
    return (
        <Fragment>
            <LoadingOverlay tag="div" active={showLoader}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: loadBackGround,
                        opacity: 0.5,
                        color: "red"
                    }),
                }}
                spinner={
                    <Loader 
                        styles={{
                            background: "",
                            color: "#000000",
                            borderColor: "#000000"
                        }} 
                        color={"#000000"} 
                        active={showLoader} 
                        type={loaderType} 
                    />
                }
            >
                <div className='loading-container'>
                    {mainContent}
                </div>
            </LoadingOverlay>
        </Fragment>
    )
}

export default Loading;
